import { createBrowserHistory } from "history";
export default createBrowserHistory();

// This file appears as uncovered in tests because it is a "Barrel" file containing no logic.
